import { render, staticRenderFns } from "./agendamentoLicencaPremioServidor.vue?vue&type=template&id=ec525cb6&scoped=true&"
import script from "./agendamentoLicencaPremioServidor.vue?vue&type=script&lang=js&"
export * from "./agendamentoLicencaPremioServidor.vue?vue&type=script&lang=js&"
import style0 from "./agendamentoLicencaPremioServidor.vue?vue&type=style&index=0&id=ec525cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec525cb6",
  null
  
)

export default component.exports